<template>
    <v-container>
    <v-row
        no-gutters
        v-for="r in rows"
        :key="r"
      >
        <v-col
          v-for="n in columns"
          :key="n"
        >
            <v-text-field
              class="mr-1"
              v-model="elements[`${r}_${n}`]"
              solo
              @input="onInput"
            >
            </v-text-field>
        </v-col>
      </v-row>
    </v-container>
</template>
<script>
    export default {
        name: 'Grid',
        props: {
          columns: {
            type: Number,
            default: 6,
          },
          rows: {
            type: Number,
            default: 6,
          },
          data: {
            type: Object,
            default() {
              return {};
            },
          },
        },
        data() {
            return {
                elements: this.data,
            };
        },
        methods: {
          onInput() {
            this.$emit('input', this.elements);
          },
        },
    };
</script>
